<template>
    <v-row :class="rowClasses" :no-gutters="resolvedNoGutters">
        <component-wrapper v-for="col in columns" :key="col.id" :config="col" />

        <div v-if="isThisOrChildSelected" class="zoezi-edit-component-wrapper-bottom-button">
            <div class="z-allow-clicks"><slot name="bottom-button"></slot></div>
        </div>
    </v-row>
</template>

<script>
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'

export default {
    name: 'zoezi-row',

    zoezi: {
        title: 'Row',
        icon: 'mdi-table-row'
    },

    computed: {
        isThisOrChildSelected() {
            if (!this.$root.edit) {
                return false;
            }
            let selected = this.$store.state.editComponent;

            let hasChild = function(x) {
                if (x == selected) {
                    return true;
                }

                return !!x.$children.find(hasChild);
            }

            return hasChild(this);
        },
        rowClasses() {
            const classes = {
                'zoezi-edit-component-wrapper': this.isThisOrChildSelected
            };
            if (this.fillWidth) {
                classes['zoezi-row-fill-width'] = true;
            } else {
                classes['zoezi-row-limit-width'] = true;
            }
            if (this.homepageFixHorizontalScrollEnabled) {
                classes['zoezi-row-responsive'] = true;
            }
            return classes;
        },
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
        resolvedNoGutters() {
            return this.noGutters || this.fillWidth;
        }
    },

    props: {
        columns: {
            title: 'Columns',
            type: Array,
            fulltype: 'componentlist',
            typeinfo: {
                component: 'zoezi-column',
                setNewConfig: (config, parent) => {
                    let cols = 0;
                    config.props = {cols: 12};
                    if (parent && parent.columns) {
                        parent.columns.forEach(col => cols += col.props.cols);
                    }
                    if (cols < 12) {
                        config.props.cols = 12 - cols;
                    }
                }
            },
            default: () => []
        },
        fillWidth: {
            title: 'Fill the entire width of the screen',
            type: Boolean,
            default: false
        },
        noGutters: {
            title: 'Minimize distance to other rows',
            type: Boolean,
            default: false
        }
    }
}
</script>
